






















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";

class CreateCollectionCodeDto {
  type: string;
  qty: number = 1;
}
@Component
export default class CreateCollectionCode extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  collectionCode: CreateCollectionCodeDto = new CreateCollectionCodeDto();
  spinShow: boolean = false;
  namespace = "collectionCode";

  types = [];
  get store() {
    return this.$store.state.collectionCode;
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getTypesForSelect`,
      })
      .then(() => {
        var re = this.store.types;
        this.types = re;
      });
  }
  async changeQty() {
    var newValue = this.collectionCode.qty;
    if (_.isNil(newValue) || newValue < 0) {
      newValue = 1;
    }
    newValue = _.min([newValue, 10000]);
    this.collectionCode.qty = newValue;
    return true;
  }
  save() {
    (this.$refs.createCollectionCodeForm as any).validate(
      async (valid: boolean) => {
        if (valid) {
          if (
            _.isNil(this.collectionCode.qty) ||
            this.collectionCode.qty <= 0
          ) {
            Util.showNoticeErrorMsg(this, Util.L("Error.InvalidQty"));
            return;
          }
          this.spinShow = true;
          this.$store
            .dispatch({
              type: `${this.namespace}/create`,
              data: this.collectionCode,
            })
            .then(() => {
              Util.showSuccessMsg(this, "Success.CreateCollectionCode");
              (this.$refs.createCollectionCodeForm as any).resetFields();
              this.$emit("save-success");
              this.$emit("input", false);
            })
            .finally(() => {
              this.spinShow = false;
            });
        }
      }
    );
  }
  cancel() {
    this.collectionCode = new CreateCollectionCodeDto();
    (this.$refs.createCollectionCodeForm as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getTypes();
    }
  }
  created() {}
  collectionCodeRules = {
    type: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur",
      },
    ],
  };
}
